import produce from 'immer';
import merge from 'lodash/merge';
import {
  entityParser,
  productsParser,
  artifactsParser,
  instrumentsToTableParser,
} from 'shared/parsers';
import { REQUEST_RATING_NEWS_FINISHED, REQUEST_RATING_NEWS } from 'store/newsFeed/newsFeedActions';
import { SEARCH_ENTITIES } from 'store/searchResult/searchResultActions';

import {
  GET_ENTITY,
  GET_ENTITY_SUCCESS,
  GET_ENTITY_ERROR,
  GET_ENTITY_PRODUCTS,
  GET_ENTITY_PRODUCTS_SUCCESS,
  GET_ENTITY_PRODUCTS_ERROR,
  GET_ENTITY_INSTRUMENTS,
  GET_ENTITY_INSTRUMENTS_SUCCESS,
  GET_ENTITY_INSTRUMENTS_ERROR,
  GET_ENTITY_RATING_NEWS,
  GET_ENTITY_RATING_NEWS_SUCCESS,
  GET_ENTITY_RATING_NEWS_ERROR,
  GET_ENTITY_RESEARCH,
  GET_ENTITY_RESEARCH_SUCCESS,
  GET_ENTITY_RESEARCH_ERROR,
  REQUEST_ENTITY_RATING,
  REQUEST_ENTITY_RATING_SUCCESS,
  REQUEST_ENTITY_RATING_ERROR,
  REQUEST_ENTITY_RATING_AND_FETCH_DATA,
  REQUEST_ENTITY_RATING_AND_FETCH_DATA_SUCCESS,
  REQUEST_ENTITY_RATING_AND_FETCH_DATA_ERROR,
  REFRESH_ENTITY,
  REQUEST_CONFIRMATION_CHANGED,
  REQUEST_SIG_ENTITY_RATING,
  REQUEST_SIG_ENTITY_RATING_SUCCESS,
  REQUEST_SIG_ENTITY_RATING_ERROR,
  SET_ENTITY_CREDIT_RATING_VISIBILITY,
} from './entityActions';

const initialState = {
  id: '',
  isPending: false,
  data: null,
  isRatingRequestPending: false,
  ratingNews: {
    data: [],
    total: null,
  },
  research: {
    data: [],
    total: null,
  },
  isRatingNewsPending: false,
  ratingRequestError: false,
  isResearchPending: false,
  instruments: {
    data: [],
    total: 0,
    isPending: true,
  },
  shouldRefresh: false,
  shouldRefreshRatingNews: false,
  shouldRefreshResearch: false,
  requestConfirmation: {
    confirmed: false,
    autoConfirm: false,
  },
  isVisible: false,
};

export function entity(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case SEARCH_ENTITIES:
    // fall through
    case GET_ENTITY:
      return { ...state, isPending: true, shouldRefresh: false };
    case GET_ENTITY_SUCCESS:
      return { ...state, isPending: false, data: entityParser(payload) };
    case GET_ENTITY_ERROR:
      return { ...state, isPending: false };
    case GET_ENTITY_PRODUCTS:
      return state;
    case GET_ENTITY_PRODUCTS_SUCCESS: {
      return produce(state, (draftState) => {
        if (draftState.data) {
          draftState.data.products = merge(draftState.data.products, productsParser(payload)); // eslint-disable-line no-param-reassign
        }
        return draftState;
      });
    }
    case GET_ENTITY_PRODUCTS_ERROR:
      return state;
    case GET_ENTITY_INSTRUMENTS:
      return { ...state, areInstrumentsPending: true };
    case GET_ENTITY_INSTRUMENTS_SUCCESS: {
      const { data, total } = payload;
      return {
        ...state,
        instruments: { data: instrumentsToTableParser(data), total, isPending: false },
      };
    }
    case GET_ENTITY_INSTRUMENTS_ERROR:
      return { ...state, instruments: { ...state.instruments, isPending: false } };
    case GET_ENTITY_RATING_NEWS:
      return { ...state, isRatingNewsPending: true, shouldRefreshRatingNews: false };
    case GET_ENTITY_RATING_NEWS_SUCCESS: {
      const { data, total } = payload;
      return {
        ...state,
        isRatingNewsPending: false,
        ratingNews: { data: artifactsParser(data), total },
      };
    }
    case GET_ENTITY_RATING_NEWS_ERROR:
      return { ...state, isRatingNewsPending: false };
    case GET_ENTITY_RESEARCH:
      return { ...state, isResearchPending: true, shouldRefreshResearch: false };
    case GET_ENTITY_RESEARCH_SUCCESS: {
      const { data, total } = payload;
      return {
        ...state,
        isResearchPending: false,
        research: { data: artifactsParser(data), total },
      };
    }
    case GET_ENTITY_RESEARCH_ERROR:
      return { ...state, isResearchPending: false };
    case REQUEST_SIG_ENTITY_RATING:
    // fall through
    case REQUEST_ENTITY_RATING:
      return { ...state, isRatingRequestPending: true };
    case REQUEST_SIG_ENTITY_RATING_SUCCESS:
    // fall through
    case REQUEST_ENTITY_RATING_SUCCESS:
      return {
        ...state,
        shouldRefresh: true,
        isRatingRequestPending: false,
        shouldRefreshResearch: true,
        shouldRefreshRatingNews: true,
      };
    case REQUEST_SIG_ENTITY_RATING_ERROR:
    // fall through
    case REQUEST_ENTITY_RATING_ERROR:
      return { ...state, isRatingRequestPending: false };
    case REQUEST_ENTITY_RATING_AND_FETCH_DATA:
      return { ...state, id: payload.id, isRatingRequestPending: true };
    case REQUEST_ENTITY_RATING_AND_FETCH_DATA_SUCCESS:
      return { ...state, isRatingRequestPending: false, ratingRequestError: false };
    case REQUEST_ENTITY_RATING_AND_FETCH_DATA_ERROR:
      return { ...state, isRatingRequestPending: false, ratingRequestError: true };
    case REQUEST_RATING_NEWS:
      return { ...state, isRatingRequestPending: true, ratingRequestError: false };
    case REQUEST_RATING_NEWS_FINISHED: {
      const isError = !!(payload && payload.error);
      return {
        ...state,
        isRatingRequestPending: false,
        shouldRefresh: !isError,
        ratingRequestError: isError,
      };
    }
    case REFRESH_ENTITY:
      return {
        ...state,
        shouldRefresh: true,
      };
    case REQUEST_CONFIRMATION_CHANGED: {
      return {
        ...state,
        requestConfirmation: {
          confirmed: payload.confirmed,
          autoConfirm: state.requestConfirmation.autoConfirm ? true : payload.autoConfirm,
        },
      };
    }
    case SET_ENTITY_CREDIT_RATING_VISIBILITY:
      return {
        ...state,
        isVisible: payload.isVisible,
      };
    default:
      return state;
  }
}
